// Modal: anotar un hito (Cara B). Evento importante de la fase de diálogo.
// Estructura idéntica a las interacciones del CRM (canal + contacto + resumen + próximo paso)
// para que al migrar el prospecto a cliente los hitos pasen 1:1 a interacciones.
import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const ProspeccionHitoModal = ({ prospectoId, contactos = [], userId, onClose, onSaved }) => {
  const [resumen,     setResumen]     = useState("");
  const [canal,       setCanal]       = useState("");
  const [contactoId,  setContactoId]  = useState("");
  const [proximoPaso, setProximoPaso] = useState("");
  const [fecha,       setFecha]       = useState(() => new Date().toISOString().slice(0, 16));
  const [canales,     setCanales]     = useState([]);
  const [submitting,  setSubmitting]  = useState(false);

  useEffect(() => {
    axios.get(`${BASE}/buscar_canales.php`)
      .then((r) => { if (Array.isArray(r.data)) setCanales(r.data); })
      .catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!resumen.trim()) return toast.error("Contá qué pasó");
    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append("prospecto_id", prospectoId);
      fd.append("tipo", "hito");
      fd.append("resumen", resumen.trim());
      if (canal)        fd.append("canal", canal);
      if (contactoId)   fd.append("contacto_id", contactoId);
      if (proximoPaso)  fd.append("proximo_paso", proximoPaso.trim());
      if (fecha)        fd.append("fecha", fecha);
      if (userId)       fd.append("usuario_id", userId);
      const r = await axios.post(`${BASE}/prospectos_interacciones_guardar.php`, fd);
      if (r.data?.success) {
        toast.success("Hito registrado");
        if (onSaved) onSaved();
      } else {
        toast.error(r.data?.mensaje || "Error al guardar");
        setSubmitting(false);
      }
    } catch {
      toast.error("Error de conexión");
      setSubmitting(false);
    }
  };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={(e) => e.stopPropagation()}>
        <h2 style={{ margin: "0 0 16px", fontSize: 18, fontWeight: 700, color: "#9f0059" }}>✱ Anotar un hito</h2>
        <p style={{ margin: "0 0 16px", color: "#888", fontSize: 12 }}>
          Un hito es un evento importante de la relación: reunión, muestra enviada, derivación, etc.
          Al convertir el prospecto a cliente, los hitos se migran como interacciones.
        </p>
        <form onSubmit={handleSubmit}>
          <Field label="Qué pasó *">
            <textarea autoFocus style={{ ...inp, minHeight: 80, fontFamily: "inherit", resize: "vertical" }}
              value={resumen} onChange={(e) => setResumen(e.target.value)}
              placeholder="Ej: reunión presencial en planta, definimos volumen para septiembre" />
          </Field>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <Field label="Canal">
              <select style={inp} value={canal} onChange={(e) => setCanal(e.target.value)}>
                <option value="">—</option>
                {canales.map((c) => <option key={c.id} value={c.nombre}>{c.nombre}</option>)}
              </select>
            </Field>
            <Field label="Contacto">
              <select style={inp} value={contactoId} onChange={(e) => setContactoId(e.target.value)}>
                <option value="">—</option>
                {contactos.map((c) => <option key={c.id} value={c.id}>{c.nombre}</option>)}
              </select>
            </Field>
          </div>
          <Field label="Próximo paso (opcional)">
            <input style={inp} value={proximoPaso} onChange={(e) => setProximoPaso(e.target.value)}
              placeholder="Ej: enviar cotización el lunes" />
          </Field>
          <Field label="Fecha">
            <input style={inp} type="datetime-local" value={fecha} onChange={(e) => setFecha(e.target.value)} />
          </Field>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 16 }}>
            <button type="button" onClick={onClose} style={btnSecondary} disabled={submitting}>Cancelar</button>
            <button type="submit" style={btnPrimary} disabled={submitting}>{submitting ? "Guardando…" : "Anotar hito"}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

const overlay = { position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 20 };
const modal   = { background: "#fff", borderRadius: 14, padding: 24, maxWidth: 520, width: "100%", maxHeight: "90vh", overflowY: "auto", boxShadow: "0 8px 32px rgba(0,0,0,0.18)" };
const inp     = { width: "100%", padding: "9px 12px", border: "1.5px solid #e0d6dc", borderRadius: 8, fontSize: 13, color: "#222", background: "#fafafa", outline: "none", boxSizing: "border-box", fontFamily: "inherit" };
const btnPrimary   = { padding: "9px 22px", background: "#9f0059", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer" };
const btnSecondary = { padding: "9px 22px", background: "#fff", color: "#666", border: "1.5px solid #e0d6dc", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer" };
const Field = ({ label, children }) => (
  <div style={{ marginBottom: 12 }}>
    <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#888", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 4 }}>{label}</label>
    {children}
  </div>
);

export default ProspeccionHitoModal;
